import React from 'react'
import MenuBar from './MenuBar'

const TopNavBar = ({isSidebarOpen , toggleSidebar}) => {
  
  return (
    <div className='navbar'>
        <div className="logo">
            <h2>Connect<span>BlueLoop</span></h2>
        </div>
        <MenuBar toggleSidebar={toggleSidebar}/>


    </div>
  )
}

export default TopNavBar